import React from 'react';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
function pdfViewer({ doc, isDownload }) {
  return (
    <div className={isDownload ? 'pdf-viewer-1' : null}>
      <DocViewer
        documents={doc}
        config={{
          header: {
            disableHeader: true,
            disableFileName: true,
            retainURLParams: true,
          },
          csvDelimiter: ',', // "," as default,
          pdfZoom: {
            defaultZoom: 1.1, // 1 as default,
            zoomJump: 0.2, // 0.1 as default,
          },
        }}
        pluginRenderers={DocViewerRenderers}
      />
    </div>
  );
}

export default pdfViewer;
